export interface INavigationConfig {
    [x: string]: any;
    Login: string;
    Home: string;
    LoginOtpScreen: string;
    PasswordSetup: string;
    Notifications: string;
    ProfileSetting: string;
    HeaterDetails: string;
    ForgotPassword: string;
    ManageInstaller: string;
    InstallerDetails: string;
    ManageCustomer: string;
    CustomerDetails: string;
    EditCustomer: string;
    ManageAdmin: string;
}
export const NavigationConfig: INavigationConfig = {
    Login: '/login',
    Home: '/home',
    LoginOtpScreen: '/verify-login-otp',
    PasswordSetup: '/set-password',
    Notifications: '/notifications',
    ProfileSetting: '/profile-setting',
    HeaterDetails: '/heater-details',
    ForgotPassword: '/forgot-password',
    ManageInstaller: '/manage-installer',
    InstallerDetails: '/manage-installer/:id',
    ManageWorkOrder: '/manage-work-order',
    ManageAdmin: '/manage-admin',
    ManageCustomer: '/manage-customer',
    CustomerDetails: '/manage-customer/:id',
    EditCustomer: '/edit-customer',
};
